const safeJSONParse = (str) => {
  if(typeof str !== 'string' ) {
    return false
  }
  try {
    const jsonReturn = JSON.parse(str)
    return jsonReturn
  } catch (error) {
    return false
  }
}
export default safeJSONParse